{
  "cycle.entite.programmes_supprimes": "Deleted programmes (kept snapshots)",
  "journalAudit.action.program.attach_proposal_withdrawn": "Attachment proposal withdrawn by the programme",
  "journalAudit.action.program.attach_proposed": "Project attachment proposed by the programme",
  "journalAudit.action.program.deleted": "Programme deleted",
  "journalAudit.action.workspace.created": "Project created"
}
